<!--html-->
<template src="../assets/html/mofawu.html"></template>
<!--css引用-->
<style src="../assets/css/mofawu.css" lang="css"></style>
<!--js脚本-->
<script>
  import NetGo from "../utils/NetGo";
  import C from "../utils/C";

  export default {
    name: 'Mofawu',
    data () {
      console.log("ssss")
      return {
        screenWidth:0,
        screeHeight:0,
        //背景
        mofawu_bg:"https://img.hatcloud.cn/20163316_1638517254298992291.png?e=2269236838&token=WsDlLjDgtDdmtdIV5Or9qEHGB6sODAC-O3wwCqF7:bZbBygxSEJRRj6KgNIEHnKdHWLQ=",
        //文字
        mafawu_title:"https://img.hatcloud.cn/20163316_1638517287408862923.png?e=2269236870&token=WsDlLjDgtDdmtdIV5Or9qEHGB6sODAC-O3wwCqF7:1-opZlQs7GYcQmHHAqVSAedVjJk=",
        mafawu_back:"https://img.hatcloud.cn/20163316_1638536982755985707.png?e=2269256565&token=WsDlLjDgtDdmtdIV5Or9qEHGB6sODAC-O3wwCqF7:9dUbCFyqI1OzE8bUlQMdDrIj-_M=",

        isSuccess:0,//失败

        fromFace:"https://headimg.hatcloud.cn/1637653831689201834.jpg?e=2268373832&token=WsDlLjDgtDdmtdIV5Or9qEHGB6sODAC-O3wwCqF7:qaPFuGFF79TpG2czGrdHvTejieE=",//我的头像
        fromName:"用户的名称",//用户的名称

        inviteFace:"https://headimg.hatcloud.cn/1637653831689201834.jpg?e=2268373832&token=WsDlLjDgtDdmtdIV5Or9qEHGB6sODAC-O3wwCqF7:qaPFuGFF79TpG2czGrdHvTejieE=",//我的头像
        inviteName:"我的名称",//我的名称

        showText:"",//提示
        huojian:"https://img.hatcloud.cn/20163316_1638530873445186935.png?e=2269250456&token=WsDlLjDgtDdmtdIV5Or9qEHGB6sODAC-O3wwCqF7:KUO0R5NIF9BKLkaRxMvQiCwfurg=",//火箭

        isAndroid:false,//是不是android
      }
    },
    mounted() {
      //关闭
      this.hideStatus();

      // 屏幕宽
      this.screenWidth = window.screen.width
      // 屏幕高
      this.screeHeight = window.screen.height

      console.log("屏幕宽度,screenWidth:"+this.screenWidth+",screeHeight:"+this.screeHeight)
      var that = this
      //修改尺寸
      if (process.client) {
        window.onresize = function () {
          return (() => {
            // 屏幕宽
            that.screenWidth = document.body.clientWidth
            // 屏幕高
            that.screeHeight = document.body.clientHeight

            console.log("屏幕尺寸改变：" + that.screenWidth + "," + that.screeHeight)
          })()
        }
      }


      let systemParam = C.getSystemInfo();
      if (systemParam && systemParam.deviceType) {
        let deviceType = systemParam.deviceType;
        console.log("deviceType:"+deviceType)
        this.isAndroid = (deviceType == "android")
      }
    },
    methods:{
      submit(event){//提交
        let koulin = this.$refs.koulin.value;
        if(!koulin){
          alert("输入的口令不能为空")
        }else{
          let that = this
          console.log("接口请求数据")
          NetGo.getResultByCommand(koulin).then(function (result) {
            console.log(result);

            //是否成功
            that.isSuccess = result.isSuccess
            if(that.isSuccess == 1){
              that.showText = ""

              that.fromFace = result.myUserInfo.imageUrl
              that.fromName = result.myUserInfo.nickname

              that.inviteFace = result.inviteUserInfo.imageUrl
              that.inviteName = result.inviteUserInfo.nickname
            }else{
              console.log("请求失败")
              that.showText = result.showText;
              // alert(result.showText)
            }
          })
        }
      },
      close(event){///重新加载页面
        console.log("点击了,popToApp")
        if (window.android) {
          window.android.popToApp();
        }
      },
      showStatus(event){///重新加载页面
        console.log("点击了,showStatus")
        if (window.android) {
          window.android.showStatus();
        }
      },
      hideStatus(event) {///重新加载页面
        console.log("点击了,hideStatus")
        if (window.android) {
          window.android.hideStatus();
        }
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Mofawu.vue